<template>
<div id="app">
  <div id="logo-bar">
    <a href="http://pokapoka.co/"><img src="./assets/img/logo.png"></a>
    <a href="#" style="float:right; font-size: 30px" v-if="isLogged" @click.prevent="logout">wyloguj</a>
  </div>
  <div id="router">
    <router-view></router-view>
  </div>
</div>
</template>

<script>
export default {
  name: 'app',
  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login')
      })
    }
  },
  computed: {
    isLogged() {
      return this.$store.getters.isLogged && this.$store.state.route.path === '/admin-panel'
    }
  }
}
</script>

<style lang="scss">
@import "assets/css/main";
@import "assets/css/gridlex.min.css";
#logo-bar {
    widht: 100%;
    height: 45px;
    text-align: left;
    margin-bottom: 65px;
}
#logo-bar a {
    margin-left: 47px;
    height: 45px;
}
#logo-bar > a > img {
    height: 100%;
}
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue